import { openBlock as t, createElementBlock as e, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ l("path", {
  fill: "#FFDA44",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), s = /* @__PURE__ */ l("path", {
  fill: "#6DA544",
  d: "M12.174 13.043h26.582C35.93 5.428 28.599 0 20 0A19.934 19.934 0 0 0 5.859 5.859l6.315 7.184Zm0 13.913h26.582C35.93 34.572 28.599 40 20 40a19.935 19.935 0 0 1-14.141-5.86l6.315-7.185Z"
}, null, -1), c = /* @__PURE__ */ l("path", {
  fill: "#D80027",
  d: "M5.859 5.859c-7.81 7.81-7.811 20.473-.001 28.283L20 20 5.86 5.859Z"
}, null, -1), h = /* @__PURE__ */ l("path", {
  fill: "#000",
  d: "m25.396 16.522.864 2.657h2.794l-2.26 1.642.863 2.657-2.26-1.642-2.26 1.642.863-2.657-2.26-1.642h2.793l.863-2.657Zm8.696 0 .864 2.657h2.793l-2.26 1.642.863 2.657-2.26-1.642-2.26 1.642.863-2.657-2.26-1.642h2.794l.863-2.657Z"
}, null, -1), d = [
  n,
  s,
  c,
  h
];
function i(_, r) {
  return t(), e("svg", o, [...d]);
}
const m = { render: i };
export {
  m as default,
  i as render
};
